import { createContext } from 'preact';
import { StateUpdater } from 'preact/hooks';
import { BasketItemProps } from '../types/basket';

export interface Image {
  alt: string;
  title: string;
  url: string;
}

interface SellingUnit {
  name: string;
  active: boolean;
  id: any;
  price: number;
}

interface AlternateSellingUnits {
  id: any;
  sellingUnit: string;
  sellingUnits: SellingUnit[];
}

export interface ProductItemProps {
  iqid: number;
  id: number;
  name: string;
  price: number;
  disable: boolean;
  image: Image;
  exclVat: boolean;
  stock: string;
  url: string;
  brand: string;
  categories: any[];
  code?: string;
  sellingunitname?: string;
  alternateSellingUnits?: AlternateSellingUnits;
  quantity?: number;
  unallocatedStock?: number;
  poa?: boolean;
  dueNextMonth?: string;
  dueNextQuantity: number;
  webShowStock?: boolean;
}

export interface FilterItem {
  ID: string;
  Name: string;
  Selected: boolean;
  Disabled: boolean;
  Count: number;
}

export interface FilterOptionProps {
  label: string;
  items: FilterItem[];
}
export interface FilterCategoriesProps {
  ID: string;
  Name: string;
  Count: number;
}
export interface SearchResultsProps {
  items: ProductItemProps[];
  page: number;
  per_page: number;
  total: number;
  total_pages: number;
  filterOptions: FilterOptionProps[];
  filterCategories?: FilterCategoriesProps[];
  loggedIn: boolean;
}

export interface SearchProps {
  categoryId?: string;
  page: number;
  limit: number;
  filters?: string[];
  search?: string;
  order?: any;
}

export interface ProductListProps {
  search: Partial<SearchProps>;
  results: Partial<SearchResultsProps>;
  products?: ProductItemProps[];
  selectedFilters?: any[];
  setSelectedFilters?: StateUpdater<any>;
  handleSelectCategory?: (categoryId: string) => void;
  activeCategory?: string;
  setSearch?: StateUpdater<any>;
  loading: boolean;
  isLoggedIn: boolean;
  handleResetSearch?: any;
  error?: any;
  categories: any[];
  basketItems?: BasketItemProps[];
  setBasketItems?: StateUpdater<BasketItemProps[]>;
  fetchBasket?: () => any;
  loadingMore: boolean;
}

export const Products = createContext<ProductListProps>({
  search: {
    page: 1,
    limit: 8,
  },
  results: {},
  products: [],
  loading: false,
  categories: [],
  activeCategory: undefined,
  isLoggedIn: false,
  loadingMore: false,
});
